import { ContentContainer, palette, shape } from '@src/core/styles';
import styled from 'styled-components';

export const TitleBlock = styled.div`
  background-color: ${palette.colors.surface_container};
  border-radius: 32px;
  margin: 16px auto;
  padding: 64px 0;
  ${ContentContainer} {
    padding: 0;
  }
`;

export const TitleInner = styled.div`
  display: flex;
  justify-content: center;
  gap: 48px;
`;

export const TitleContent = styled.div`
  max-width: 690px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const TitleVideo = styled.div`
  width: 100%;
  max-width: 690px;
  height: 372px;
  background-color: ${palette.colors.onsurface_variant};
  border-radius: ${shape.rounding.XXL};
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.3),
    0px 8px 12px 6px rgba(0, 0, 0, 0.15);
  & div {
    width: 100%;
  }
  & iframe {
    border-radius: ${shape.rounding.L};
    border: none;
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: 24px;
  margin-top: 24px;
`;
